<template>
  <div style="height: 100%">
    <div class="actionBtn">
      <el-button type="primary" @click="stageGo(0)"
        ><el-icon> <plus /> </el-icon><span>新增</span></el-button
      >
    </div>
    <el-dialog v-model="dialogFormVisible" :title="title">
      <el-form :model="formState" :rules="rules">
        <el-form-item
          label="所属分组："
          :label-width="formLabelWidth"
          prop="tag_group_id"
        >
          <el-select
            v-model="formState.tag_group_id"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="item in getTagsGroupList"
              :key="item.tag_id"
              :label="item.tag_name_ch"
              :value="item.tag_id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="中文名："
          :label-width="formLabelWidth"
          prop="tag_name_ch"
        >
          <el-input
            v-model="formState.tag_name_ch"
            placeholder="客户标签中文名"
            clearable
          />
        </el-form-item>
        <el-form-item
          label="英文名："
          prop="tag_name_en"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="formState.tag_name_en"
            placeholder="客户标签英文名"
            clearable
          />
        </el-form-item>
        <el-form-item
          label="标签色："
          prop="color_code"
          :label-width="formLabelWidth"
        >
          <el-color-picker
            v-model="formState.color_code"
            show-alpha
            :predefine="predefineColors"
          />
        </el-form-item>
        <el-form-item
          label="排序："
          prop="tag_sort"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="formState.tag_sort"
            maxlength="4"
            placeholder="客户标签排序"
            clearable
          />
        </el-form-item>
        <el-form-item label="状态：" :label-width="formLabelWidth">
          <el-switch
            v-model="formState.tag_status"
            class="ml-2"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="开启"
            inactive-text="关闭"
          />
        </el-form-item>
        <el-form-item label="备注：" :label-width="formLabelWidth">
          <el-input type="textarea" v-model="formState.tag_remark" />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取消</el-button>
          <el-button type="primary" @click="add">{{ goTitle }}</el-button>
        </span>
      </template>
    </el-dialog>
    <div class="content">
      <el-table
        :data="dataSource"
        style="width: 100%; font-size: 12px"
        row-key="tag_id"
        height="100%"
        stripe:true
      >
        <el-table-column fixed prop="tag_id" label="ID" width="100" />
        <el-table-column prop="tag_name_ch" label="中文名" width="150" fixed />
        <el-table-column prop="tag_name_en" label="英文名" width="150" />
        <el-table-column prop="tag_group_id_v" label="分组" width="200" />
        <el-table-column prop="color_code" label="颜色" width="200">
          <template #default="scope">
            <span :style="{ color: scope.row.color_code }"> 标签颜色</span>
          </template>
        </el-table-column>
        <el-table-column prop="tag_sort" label="排序" width="200" />
        <el-table-column prop="tag_status" label="状态" width="120">
          <template #default="scope">
            <span
              :style="{
                color: scope.row.tag_status == 1 ? 'green' : 'red',
              }"
            >
              {{ scope.row.tag_status == 1 ? "开启" : "关闭" }}</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="tag_remark" label="备注" width="150" />
        <el-table-column fixed="right" label="操作" width="200">
          <template #default="scope">
            <el-button type="primary" @click="stageGo(scope.row)">
              <el-icon> <edit /> </el-icon><span>编辑</span></el-button
            >
            <el-button type="danger" @click="del(scope.row.tag_id)"
              ><el-icon> <delete /> </el-icon><span>删除</span></el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="demo-pagination-block">
        <el-pagination
          :currentPage="currentPage"
          :page-size="pageSize"
          :page-sizes="[30, 50, 100]"
          :background="true"
          layout="sizes, prev, pager, next, jumper,total"
          :total="pageTotal"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { ref, reactive, toRefs, onMounted } from "vue";
import {
  customerTagsList,
  customerTagsAdd,
  customerTagsDel,
  getTagsGroupList,
} from "@/network/basic.js";
import { Delete, Edit, Plus, Search } from "@element-plus/icons-vue";
import { ElMessage, ElMessageBox } from "element-plus";

export default {
  components: {
    Delete,
    Edit,
    Plus,
    Search,
  },
  setup() {
    const currentPage = ref(1);
    const pageSize = ref(30);
    const pageTotal = ref(0);
    const state = reactive({
      getTagsGroupList: [],
      dataSource: [],
      title: "添加客户标签",
      goTitle: "添加",
      dialogFormVisible: false,
      formLabelWidth: "140px",
    });
    const rules = reactive({
      tag_name_en: [
        {
          required: true,
          message: "请输入客户标签英文名",
          trigger: "blur",
        },
      ],
      tag_name_ch: [
        {
          required: true,
          message: "请输入客户标签中文名",
          trigger: "blur",
        },
      ],
      color_code: [
        {
          required: true,
          message: "请选择客户标签颜色",
          trigger: "blur",
        },
      ],
    });
    const formState = reactive({
      tag_id: 0,
      tag_group_id: 0,
      tag_name_en: "",
      tag_name_ch: "",
      color_code: "",
      tag_sort: 0,
      tag_status: 1,
      tag_remark: "",
    });
    const predefineColors = ref([
      "rgba(0, 0, 0,1)",
      "rgba(188, 89, 89,1)",
      "rgba(216, 117, 56,1)",
      "rgba(32, 152, 144,1)",
      "rgba(75, 103, 157,1)",
      "rgba(89, 93, 190,1)",
      "rgba(51, 51, 51,1)",
      "rgba(228, 62, 62,1)",
      "rgba(235, 153, 85,1)",
      "rgba(93, 137, 233,1)",
      "rgba(141, 84, 189,1)",
      "rgba(123, 130, 145,1)",
      "rgba(238, 123, 123,1)",
      "rgba(226, 173, 40,1)",
      "rgba(128, 196, 99,1)",
      "rgba(74, 168, 235,1)",
      "rgba(172, 172, 172,1)",
    ]);
    const getList = () => {
      customerTagsList({
        currentPage: currentPage.value,
        pageSize: pageSize.value,
        listType: 1,
      }).then((res) => {
        if (res.code == 0) {
          state.dataSource = res.data.lists;
          pageTotal.value = res.data.pageTotal;
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const handleSizeChange = (val) => {
      pageSize.value = val;
      getList();
    };
    const handleCurrentChange = (val) => {
      currentPage.value = val;
      getList();
    };
    onMounted(() => {
      getList();
    });
    //------------以上为列表数据

    const stageGo = (row) => {
      state.dialogFormVisible = true;
      getTagsGroupList().then((res) => {
        if (res.code == 0) {
          state.getTagsGroupList = res.data;
        } else {
          ElMessage.error(res.msg);
        }
      });
      if (row) {
        Object.assign(formState, row);
        state.goTitle = "更新";
        state.title = "修改客户标签信息";
        formState.tag_status = Boolean(row.tag_status);
      } else {
        state.goTitle = "添加";
        state.title = "添加客户标签";
        formState.tag_id = 0;
        formState.tag_group_id = "一级分类";
        formState.tag_name_en = "";
        formState.tag_name_ch = "";
        formState.color_code = "rgba(97, 188, 129, 1)";
        formState.tag_sort = 0;
        formState.tag_status = true;
        formState.tag_remark = "";
      }
    };
    const add = () => {
      if (!formState.tag_name_ch) {
        ElMessage.info("请填写客户标签名称");
        return false;
      }
      customerTagsAdd(formState).then((res) => {
        if (res.code == 0) {
          ElMessage.success(res.msg);
          state.dialogFormVisible = false;
          getList();
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    //------------以上为编辑和修改数据
    const del = (tag_id) => {
      if (!tag_id) {
        ElMessage("所选数据为空，请重新选择！");
      } else {
        ElMessageBox.confirm("确定要删除该条数据吗?", "警告", {
          confirmButtonText: "删除",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            customerTagsDel({ tag_id: tag_id }).then((res) => {
              if (res.code == 0) {
                ElMessage.success(res.msg);
                getList();
              } else {
                ElMessage.error(res.msg);
              }
            });
          })
          .catch(() => {
            ElMessage({
              type: "info",
              message: "删除取消",
            });
          });
      }
    };

    return {
      ...toRefs(state),
      rules,
      formState,
      stageGo,
      add,
      del,
      currentPage,
      pageSize,
      pageTotal,
      handleSizeChange,
      handleCurrentChange,
      predefineColors,
    };
  },
};
</script>
<style scoped>
.el-select :deep .select-popper {
  z-index: 8888 !important;
  top: auto !important;
  left: auto !important;
}
.actionBtn {
  padding: 10px 0;
  display: flex;
  justify-content: flex-end;
}
.content {
  height: calc(100% - 180px);
  position: relative;
}
.el-table {
  position: absolute;
}
.el-table__header {
  width: 100%;
}
.el-table__body {
  height: calc(100% - 40px);
}
.el-pagination {
  position: absolute;
  bottom: -56px;
  right: 20px;
}
</style>
